// Local cart values are untrusted and may come from an older app build.
export function normalizeCart(value) {
  if (!Array.isArray(value)) return [];
  const items = new Map();
  for (const item of value) {
    if (!item || typeof item.product_id !== 'string' || !item.product_id.trim()) continue;
    const quantity = Number(item.quantity);
    const price = Number(item.price);
    if (!Number.isSafeInteger(quantity) || quantity <= 0 || item.price == null || !Number.isFinite(price) || price < 0) continue;
    const existing = items.get(item.product_id);
    const combined = quantity + (existing?.quantity || 0);
    if (!Number.isSafeInteger(combined)) continue;
    items.set(item.product_id, {
      product_id: item.product_id,
      sku: typeof item.sku === 'string' ? item.sku : '',
      name: typeof item.name === 'string' ? item.name : 'Product',
      specification: typeof item.specification === 'string' ? item.specification : '',
      price, quantity: combined,
      weight_oz: Number(item.weight_oz) > 0 && Number.isFinite(Number(item.weight_oz)) ? Number(item.weight_oz) : null,
    });
  }
  return [...items.values()];
}

export function cartStorageKey(user) {
  return user?.id ? `batchtrue:cart:v2:account:${encodeURIComponent(user.id)}` : 'batchtrue:cart:v2:visitor';
}

export function readCart(key = 'cart') {
  try { return normalizeCart(JSON.parse(localStorage.getItem(key) || '[]')); }
  catch { return []; }
}
